function cov_72gz7rar() {
  var path = "/__w/code/code/js/packages/cinderblocks/src/platform/EventCard/EventCard.tsx";
  var hash = "98f188eb633eefb3b4d65fde748729d241ff7254";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/cinderblocks/src/platform/EventCard/EventCard.tsx",
    statementMap: {
      "0": {
        start: {
          line: 56,
          column: 51
        },
        end: {
          line: 103,
          column: 1
        }
      },
      "1": {
        start: {
          line: 57,
          column: 90
        },
        end: {
          line: 57,
          column: 95
        }
      },
      "2": {
        start: {
          line: 58,
          column: 2
        },
        end: {
          line: 102,
          column: 4
        }
      },
      "3": {
        start: {
          line: 105,
          column: 40
        },
        end: {
          line: 114,
          column: 1
        }
      },
      "4": {
        start: {
          line: 116,
          column: 46
        },
        end: {
          line: 138,
          column: 1
        }
      },
      "5": {
        start: {
          line: 117,
          column: 2
        },
        end: {
          line: 130,
          column: 3
        }
      },
      "6": {
        start: {
          line: 118,
          column: 4
        },
        end: {
          line: 129,
          column: 6
        }
      },
      "7": {
        start: {
          line: 133,
          column: 2
        },
        end: {
          line: 137,
          column: 4
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 56,
            column: 51
          },
          end: {
            line: 56,
            column: 52
          }
        },
        loc: {
          start: {
            line: 56,
            column: 62
          },
          end: {
            line: 103,
            column: 1
          }
        },
        line: 56
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 116,
            column: 46
          },
          end: {
            line: 116,
            column: 47
          }
        },
        loc: {
          start: {
            line: 116,
            column: 57
          },
          end: {
            line: 138,
            column: 1
          }
        },
        line: 116
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 59,
            column: 26
          },
          end: {
            line: 59,
            column: 73
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 59,
            column: 56
          },
          end: {
            line: 59,
            column: 57
          }
        }, {
          start: {
            line: 59,
            column: 60
          },
          end: {
            line: 59,
            column: 73
          }
        }],
        line: 59
      },
      "1": {
        loc: {
          start: {
            line: 62,
            column: 9
          },
          end: {
            line: 75,
            column: 9
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 63,
            column: 10
          },
          end: {
            line: 72,
            column: 17
          }
        }, {
          start: {
            line: 74,
            column: 10
          },
          end: {
            line: 74,
            column: 48
          }
        }],
        line: 62
      },
      "2": {
        loc: {
          start: {
            line: 66,
            column: 29
          },
          end: {
            line: 66,
            column: 61
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 66,
            column: 29
          },
          end: {
            line: 66,
            column: 44
          }
        }, {
          start: {
            line: 66,
            column: 48
          },
          end: {
            line: 66,
            column: 61
          }
        }],
        line: 66
      },
      "3": {
        loc: {
          start: {
            line: 78,
            column: 27
          },
          end: {
            line: 78,
            column: 82
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 78,
            column: 42
          },
          end: {
            line: 78,
            column: 50
          }
        }, {
          start: {
            line: 78,
            column: 53
          },
          end: {
            line: 78,
            column: 82
          }
        }],
        line: 78
      },
      "4": {
        loc: {
          start: {
            line: 100,
            column: 7
          },
          end: {
            line: 100,
            column: 83
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 100,
            column: 8
          },
          end: {
            line: 100,
            column: 23
          }
        }, {
          start: {
            line: 100,
            column: 27
          },
          end: {
            line: 100,
            column: 39
          }
        }, {
          start: {
            line: 100,
            column: 44
          },
          end: {
            line: 100,
            column: 83
          }
        }],
        line: 100
      },
      "5": {
        loc: {
          start: {
            line: 117,
            column: 2
          },
          end: {
            line: 130,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 117,
            column: 2
          },
          end: {
            line: 130,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 117
      },
      "6": {
        loc: {
          start: {
            line: 117,
            column: 6
          },
          end: {
            line: 117,
            column: 33
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 117,
            column: 6
          },
          end: {
            line: 117,
            column: 19
          }
        }, {
          start: {
            line: 117,
            column: 23
          },
          end: {
            line: 117,
            column: 33
          }
        }],
        line: 117
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0
    },
    f: {
      "0": 0,
      "1": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0, 0],
      "5": [0, 0],
      "6": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "98f188eb633eefb3b4d65fde748729d241ff7254"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_72gz7rar = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_72gz7rar();

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import { Icon, Card, Flex, Box, Text } from '@opendoor/bricks/core';
import { EventCardChip } from './EventCardChip';
import { ClickableCardWithMetrics } from './ClickableCardWithMetrics';
cov_72gz7rar().s[0]++;

/**
 * Renders an event as a card.
 *
 * Non-interactive:
 *    - Only renders information
 * Button:
 *    - Renders as a button
 *    - Tracks the click based on the analyticsName passed
 *
 * Must accept either Icon(name,size,color) or Chip props (firstLine,secondLine)
 */
export var EventCard = function EventCard(props) {
  cov_72gz7rar().f[0]++;

  var _ref = (cov_72gz7rar().s[1]++, props),
      title = _ref.title,
      subtitle = _ref.subtitle,
      chipOrIconProps = _ref.chipOrIconProps,
      backgroundColor = _ref.backgroundColor,
      textAsColumn = _ref.textAsColumn,
      dataTestId = _ref.dataTestId;

  cov_72gz7rar().s[2]++;
  return /*#__PURE__*/React.createElement(CardWrapper, _extends({
    padding: props.padding === undefined ? (cov_72gz7rar().b[0][0]++, 5) : (cov_72gz7rar().b[0][1]++, props.padding)
  }, props), /*#__PURE__*/React.createElement(Flex, {
    alignItems: "center",
    "data-testid": dataTestId
  }, 'name' in chipOrIconProps ? (cov_72gz7rar().b[1][0]++, /*#__PURE__*/React.createElement(Flex, {
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: (cov_72gz7rar().b[2][0]++, backgroundColor) || (cov_72gz7rar().b[2][1]++, 'neutrals100'),
    width: 44,
    height: 44,
    borderRadius: "roundedSquare"
  }, /*#__PURE__*/React.createElement(Icon, chipOrIconProps))) : (cov_72gz7rar().b[1][1]++, /*#__PURE__*/React.createElement(EventCardChip, chipOrIconProps)), /*#__PURE__*/React.createElement(Box, {
    ml: 4
  }, /*#__PURE__*/React.createElement(Flex, {
    flexDirection: textAsColumn ? (cov_72gz7rar().b[3][0]++, 'column') : (cov_72gz7rar().b[3][1]++, ['column', null, null, 'row']),
    "data-testid": "scheduled-event"
  }, /*#__PURE__*/React.createElement(Text, {
    fontWeight: "semibold",
    fontSize: ['s0', null, 's1'],
    lineHeight: ['s0', null, 's1'],
    mr: [0, null, 2]
  }, title), /*#__PURE__*/React.createElement(Text, {
    fontWeight: "normal",
    fontSize: ['s00', null, 's1'],
    lineHeight: [1, null, null, 's1']
  }, subtitle)))), ((cov_72gz7rar().b[4][0]++, !!props.onClick) || (cov_72gz7rar().b[4][1]++, !!props.href)) && (cov_72gz7rar().b[4][2]++, /*#__PURE__*/React.createElement(Icon, {
    size: 16,
    name: "chevron-right"
  })));
};
var CARD_STYLES = (cov_72gz7rar().s[3]++, {
  border: '1px',
  borderColor: 'neutrals30',
  borderStyle: 'solid',
  borderRadius: 'semiRounded',
  textAlign: 'start',
  width: '100%',
  alignItems: 'center',
  justifyContent: ['space-between', 'center']
});
cov_72gz7rar().s[4]++;

var CardWrapper = function CardWrapper(props) {
  cov_72gz7rar().f[1]++;
  cov_72gz7rar().s[5]++;

  if ((cov_72gz7rar().b[6][0]++, props.onClick) || (cov_72gz7rar().b[6][1]++, props.href)) {
    cov_72gz7rar().b[5][0]++;
    cov_72gz7rar().s[6]++;
    return /*#__PURE__*/React.createElement(ClickableCardWithMetrics, _extends({}, CARD_STYLES, {
      analyticsName: "event-".concat(props.analyticsName),
      onClick: props.onClick,
      href: props.href,
      justifyContent: "space-between",
      padding: props.padding
    }), props.children);
  } else {
    cov_72gz7rar().b[5][1]++;
  } // non-interactive


  cov_72gz7rar().s[7]++;
  return /*#__PURE__*/React.createElement(Card, _extends({}, CARD_STYLES, {
    padding: props.padding
  }), props.children);
};